import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';

import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-airdisk-drum-break-costs',
  templateUrl: './airdisk-drum-break-costs.component.html',
  styleUrls: ['./airdisk-drum-break-costs.component.scss'],
  standalone: false
})
export class AirdiskDrumBreakCostsComponent {
  private readonly destroy$ = new Subject<void>();
  fleetInfoData: any;
  subscription = new Subscription();
  isTractor: boolean = false;
  constructor(public airdiskService: AirdiskbrakeService, private readonly cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.subscription = this.airdiskService.selectedOption$.subscribe(option => {
      if (option) {
        this.isTractor = option === 'Tractor';
      } else {
        this.isTractor = true;
      }
    });

    this.airdiskService.fleetInfoData$.subscribe(x => {
      this.fleetInfoData = x;
    });

    this.airdiskService.drumBrakeServiceCosts$.pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data != null) {
          this.drumBreakServiceCostsForm.patchValue({
            drumBreakServiceLabourCost: data.drumBreakServiceLabourCost || 0.17,
            totalDrumBreakServiceUnitCost: data.totalDrumBreakServiceUnitCost.toFixed(2) || 2652.00,
            drumBreakServiceAnnualFrequency: data.drumBreakServiceAnnualFrequency || 4,
            totalDrumBreakServiceFleetCost: data.totalDrumBreakServiceFleetCost || 2652000
          });
        }

      });
    this.calculateAndSetSum();
  }

  drumBreakServiceCostsForm = new FormGroup({
    drumBreakServiceLabourCost: new FormControl(0.17, { validators: Validators.required }),
    totalDrumBreakServiceUnitCost: new FormControl(null, { validators: Validators.required }),
    drumBreakServiceAnnualFrequency: new FormControl(4, { validators: Validators.required }),
    totalDrumBreakServiceFleetCost: new FormControl(null, { validators: Validators.required })
  });

  get form() {
    return this.drumBreakServiceCostsForm.controls;
  }

  onFormChanges(): void {
    this.drumBreakServiceCostsForm.get('drumBreakServiceLabourCost')?.valueChanges.subscribe(() => {
      this.calculateAndSetSum();
    });

    this.storeDataOnChange();
  }

  calculateAndSetSum(): void {

    //Fleet Information:
    const E13 = this.fleetInfoData?.fleetSize;
    const E14 = this.fleetInfoData?.totalNumberOfAxlesPerUnit;
    const E15 = this.isTractor ? this.fleetInfoData?.tractorTradeInCycle : this.fleetInfoData?.trailerTradeInCycle;
    const E20 = this.fleetInfoData?.fleetMaintenanceLaborRate;

    // Drum-break-service-cost
    const E40 = +this.drumBreakServiceCostsForm.get('drumBreakServiceLabourCost')?.value || 0;
    const E41 = +this.drumBreakServiceCostsForm.get('drumBreakServiceAnnualFrequency')?.value || 0;


    const E42 = E14 * 2 * E40 * E41 * E20 * E15;
    const E43 = Math.round(E42 * E13);

    this.drumBreakServiceCostsForm.patchValue({
      totalDrumBreakServiceUnitCost: E42.toFixed(2),
      totalDrumBreakServiceFleetCost: E43.toFixed(2),
    });


  }

  storeDataOnChange() {

    if (this.drumBreakServiceCostsForm.valid) {
      this.drumBreakServiceCostsForm.patchValue({
        totalDrumBreakServiceUnitCost: Number(this.drumBreakServiceCostsForm.controls['totalDrumBreakServiceUnitCost'].value),
        totalDrumBreakServiceFleetCost: Number(this.drumBreakServiceCostsForm.controls['totalDrumBreakServiceFleetCost'].value),
      });
      this.airdiskService.drumBrakeServiceCosts$.next(this.drumBreakServiceCostsForm.value);
    }
    else {
      this.drumBreakServiceCostsForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }

  endaSureNxt() {
    this.storeDataOnChange();
    this.airdiskService.currentComponent$.next('csaViolationCosts');
  }

  endaSureBack() {
    this.airdiskService.currentComponent$.next('frictionMaintainance');
    this.storeDataOnChange();
  }

  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.subscription.unsubscribe();
  }
}
